const languages = [
  {
    label: 'En',
    value: 'en',
    isDefault: true,
  },
];

module.exports = { languages };



// WEBPACK FOOTER //
// ./src/config/languages.js